import { GET_TESTIMONIALS } from '../constants/testimonial';
import { SHOW_LOADING, HIDE_LOADING } from '../constants/commons';

const initialState = {
    loading: false,
    testimonials: [],
}

export const testimonialReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case GET_TESTIMONIALS:
            return {...state, testimonials: payload};
        case SHOW_LOADING:
            return {...state, loading: true};
        case HIDE_LOADING:
            return {...state, loading: false};
        default:
            return state;
    }
} 